import { use, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthProviderContext from 'shared/features/auth/authentication/providers/contexts/auth-provider-context';
import { clearAllActiveFilters } from 'shared/utils/clear-filters';

type UserMenu = {
  isMenuOpen: boolean;
  isLogoutPopupOpen: boolean;
  tenantName: string;
  fullName: string;
  initials: string;
  goToRoute: (route: string) => void;
  toggleMenu: () => void;
  closeMenu: () => void;
  openLogoutPopUp: () => void;
  closeLogoutPopUp: () => void;
  confirmLogout: () => void;
};

export const useUserMenu = (): UserMenu => {
  const navigate = useNavigate();
  const {
    tenant: { name: authTenantName },
    fullname: authFullName,
    initials: authInitials,
    backChannelLogout,
  } = use(AuthProviderContext);

  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
  const [isLogoutPopupOpen, setIsLogoutPopupOpen] = useState<boolean>(false);

  const goToRoute = (route: string): void => {
    closeMenu();
    navigate(route);
  };

  const toggleMenu = (): void => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = (): void => {
    setIsMenuOpen(false);
  };

  const openLogoutPopUp = (): void => {
    if (!isLogoutPopupOpen) setIsLogoutPopupOpen(true);
  };

  const closeLogoutPopUp = (): void => {
    if (isLogoutPopupOpen) setIsLogoutPopupOpen(false);
  };

  const confirmLogout = (): void => {
    clearAllActiveFilters();
    backChannelLogout();
  };

  return {
    isMenuOpen,
    isLogoutPopupOpen,
    tenantName: authTenantName || '',
    fullName: authFullName || '',
    initials: authInitials || '',
    goToRoute,
    toggleMenu,
    closeMenu,
    openLogoutPopUp,
    closeLogoutPopUp,
    confirmLogout,
  };
};
